<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :fill="svgFill" 
        viewBox="0 0 16 16" 
        class="size-4"
    >
        <path d="M3.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" />
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps(['fill'])

const svgFill = computed(() => {
    return props.fill ? props.fill : 'black'
})
</script>